import './PagePortfolio.scss';
import Project from '../components/Project/Project';
import ProjectDesc from '../components/ProjectDesc/ProjectDesc';
import { useState, useEffect } from 'react';
import { useContext } from 'react';
import { ThemeContext } from '../context/ThemeContext';
import projects from '../utils/products.mock.js';


const PagePortfolio = () => {
    //tema claro y oscuro
    const {theme, darkTheme, lightTheme} = useContext(ThemeContext);

    useEffect(() => {
        if(theme) {
            lightTheme();
        } else {
            darkTheme();
        }
    }, [theme, lightTheme, darkTheme])

    //clases a los botones de 'personal' y 'estudiantil'
    const addClassPers = () => {
        let pers = document.getElementById('pers');
        let estu = document.getElementById('estu');
        estu.classList.remove('type');
        pers.classList.add('type');
    }

    const addClassEstu = () => {
        let pers = document.getElementById('pers');
        let estu = document.getElementById('estu');
        pers.classList.remove('type');
        estu.classList.add('type');
    }

    //funciones para los botones 'personal' y 'estudiantil'
    const [personal, setPersonal] = useState('block');

    const togglePersonal = () => {
        if(personal === 'none') {
            setPersonal('block');
            setStudent('none');
        } 
    }

    const [student, setStudent] = useState('none');

    const toggleStudent = () => {
        if(student === 'none') {
            setStudent('block');
            setPersonal('none');
        }
    }

    //llamada al mock
    const [listProjects, setListProjects] = useState([])

    useEffect(() => {
        const getProjects = new Promise((resolve, reject) => {
            resolve(projects)
        })
    
        getProjects
        .then((res)=>{
            setListProjects(res)
        })
        .catch((error)=>{
            console.log('error en la llamada al mock: ',error);
        })
    }, [])

    return(
        <div className='page-portfolio'>
            <div className='page-portfolio__subtitle text'>
                - portafolio -
            </div>
            <div className='page-portfolio__title'>
                <h1>Proyectos</h1>
            </div>
            <div className='page-portfolio__projects'>
                <div className='page-portfolio__projects__types'>
                    <p id='pers' className='type'
                    onClick={()=>{
                        togglePersonal();
                        addClassPers();
                    }}>
                        Personales
                    </p>
                    <p id='estu' 
                    onClick={()=>{
                        toggleStudent();
                        addClassEstu();
                    }}>
                        Estudiantiles
                    </p>
                </div>
                <div className='page-portfolio__projects__items'>
                    <div style={{display:personal}}>
                    {
                        listProjects[1]?.map((itemProject) => {
                            return(
                                <div className='item' key={itemProject.id}>
                                    <div className='item__img'>
                                        <Project data={itemProject}/>
                                    </div>
                                    <div className='item__desc'>
                                        <ProjectDesc data={itemProject}/>
                                    </div>
                                </div>
                            )
                        })
                    }
                    </div>
                    <div style={{display:student}}>
                    {
                        listProjects[0]?.map((itemProject) => {
                            return(
                                <div className='item' key={itemProject.id}>
                                    <div className='item__img'>
                                        <Project data={itemProject}/>
                                    </div>
                                    <div className='item__desc'>
                                        <ProjectDesc data={itemProject}/>
                                    </div>
                                </div>
                            )
                        })
                    }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PagePortfolio;